<template>
    <b-row>
        <b-col md="12">
            <component-header
                title="Return & Cancellation Policy"
                @search-query="(val) => (filter = val)"
                :hasClear="false"
                @create-press="handleCreate"
                @reload-data="getReturnPolicyList"
                createButtonText="Add Return & Cancellation Policy"
                :isLoading="loading"
            />
        </b-col>
        <b-col md="12">
            <b-card class="custome-card">
                <div class="table-responsive">
                    <b-table
                        class="professional-stacked-table"
                        :dark="false"
                        :hover="true"
                        :striped="false"
                        :bordered="true"
                        :small="false"
                        :fixed="false"
                        responsive="sm"
                        stacked="md"
                        :items="fetchReturnPolicy"
                        :fields="returnPolicyFields"
                        :current-page="currentPage"
                        :per-page="perPage"
                        thead-class="header"
                        @filtered="onFilter"
                        :filter="filter"
                        :filter-included-fields="filterIncludedFields"
                        show-empty
                        :busy="loading"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(createdAt)" slot-scope="data">
                            <div>{{ data.item.createdAt | formatedate }}</div>
                        </template>
                        <template slot-scope="data" slot="cell(action)">
                            <div class="d-flex">
                                <ActionButtonGroup
                                    showView
                                    showEdit
                                    showDelete
                                    @view="returnPolicyView(data.item)"
                                    @edit="returnPolicyEdit(data.item)"
                                    @delete="deleteReturnPolicy(data.item)"
                                />
                            </div>
                        </template>
                        <template slot="cell(empty)">
                            <div v-if="loading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>
                    </b-table>
                </div>
                <div
                    class="pagination-wrapper"
                    v-if="fetchReturnPolicy.length > perPage"
                >
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="filterCount"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import ComponentHeader from "@/components/componentNewHeader/index.vue";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";
import {
    RETURN_POLICY_TABLE_FIELDS,
    FILTER_INCLUDED_FIELDS,
} from "@/views/setup/return-policy/constants";

export default {
    name: "Return  & Cancellation Policy",
    components: {
        ComponentHeader,
        ActionButtonGroup,
    },
    data() {
        return {
            filterCount: 0,
            filter: "",
            loading: false,
            perPage: 10,
            currentPage: 1,
            sortBy: "createdAt",
            sortDesc: true,
            returnPolicyFields: RETURN_POLICY_TABLE_FIELDS,
            filterIncludedFields: FILTER_INCLUDED_FIELDS,
        };
    },
    computed: {
        ...mapState({
            fetchReturnPolicy: (state) => state.returnPolicy.returnPolicy,
        }),
    },
    filters: {
        formatedate(value) {
            if (!value) return "";
            return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
        },
    },
    mounted() {
        this.getReturnPolicyList();
    },
    methods: {
        handleCreate() {
            this.$router.push({ path: "/setup/policy/create" });
        },
        async getReturnPolicyList() {
            this.loading = true;
            try {
                await this.$store.dispatch(
                    "returnPolicy/fetchReturnPolicyAction",
                );
            } catch (error) {
                this.$toasted.error("Unable to fetch data");
            } finally {
                this.loading = false;
            }
        },
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        async deleteReturnPolicy(data) {
            const result = await this.$swal({
                title: "Delete this Policy?",
                text: "Are you sure? This will be Remove?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            });
            if (!result.value) return;
            this.loading = true;
            try {
                await this.$store.dispatch(
                    "returnPolicy/deleteReturnPolicyAction",
                    data._id,
                );
                await this.$swal({
                    type: "success",
                    title: "Success",
                    text: "Policy Deleted Successfully!",
                });
                await this.getReturnPolicyList();
            } catch (error) {
                this.$toasted.error("Unable to delete policy");
            } finally {
                this.loading = false;
            }
        },
        returnPolicyView(data) {
            this.$router.push({
                name: "View Return Policy",
                params: { id: data._id },
            });
        },
        returnPolicyEdit(data) {
            this.$router.push({
                name: "Edit Return Policy",
                params: { id: data._id },
            });
        },
    },
};
</script>

<style scoped>
.btn-edit-policy {
    background: #fe7b08;
    border-color: #fe7b08;
}
.pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}
</style>
